module.exports = __webpack_public_path__ + "img/d1.13dce185.jpg";